var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"fonte-sincronizador-c"}},[_c('p',{class:_vm.fonteSincronizadorC.qtdDiasUltimaAtualizacao > 3 ? 'font-color-red' : ''},[_c('b',[_vm._v("Fonte:")]),_vm._v(" "+_vm._s(' e-SUS, ' + _vm.fonteSincronizadorC.ultimaAtualizacao)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }